/* eslint-disable no-case-declarations */
import {
    CHANGE_LANG,
    SHOW_DEVELOP,
    SET_ALERT,
    SHOW_LOADING,
    SET_CATEGORIES,
    SET_PRODUCTS,
    SET_PRODUCT_QUERY,
    SET_USER_MENUS,
    SET_LANGUAGES,
} from '../actions/system';
import { SET_SETTINGS } from '../actions/settings';
import Cookies from 'js-cookie';

let lang = 'mn';
if (typeof window !== 'undefined') {
    const chosenLang = Cookies.get('chosen_lang');
    if (chosenLang) lang = chosenLang;
}

const initialState = {
    lang: lang,
    languages: [],
    userMenus: [],
    showDevelop: false,
    showLoading: false,
    categories: [],
    products: [],
    productQuery: null,
    alert: { isShow: false, type: 'success', message: '' },
    settings: {},
};

const reducer = (state, action) => {
    switch (action.type) {
        case CHANGE_LANG:
            return { ...state, lang: action.data };
        case SHOW_DEVELOP:
            return { ...state, showDevelop: action.data };
        case SET_ALERT:
            return { ...state, alert: action.data };
        case SHOW_LOADING:
            return { ...state, showLoading: action.data };
        case SET_CATEGORIES:
            return { ...state, categories: action.data };
        case SET_PRODUCTS:
            return { ...state, products: action.data };
        case SET_PRODUCT_QUERY:
            return { ...state, productQuery: action.data };
        case SET_USER_MENUS:
            return { ...state, userMenus: action.data };
        case SET_LANGUAGES:
            return { ...state, languages: action.data };
        case SET_SETTINGS:
            return { ...state, settings: action.data };
        default:
            return state;
    }
};

export default [reducer, initialState];
